module.exports = __webpack_public_path__ + "img/dancing_panda1.d3dc6669.gif";